import { MenuEnum } from '@/settings/enum';
import { createSlice } from '@reduxjs/toolkit';

/**
 * 权限 / 授权信息状态管理
 */
export const menuSlice = createSlice({
  name: MenuEnum.NAME,
  initialState: {
    [MenuEnum.MENU_DETAILS]: {},
  },
  reducers: {
    setEnumItem: (state, { payload }: { payload: { details: any } }) => {
      const { details } = payload;
      state[MenuEnum.MENU_DETAILS] = details;
    },
    removeEnumItem: (state) => {
      state[MenuEnum.MENU_DETAILS] = {};
    },
  },
});

// 每个 case reducer 函数会生成对应的 Action creators
export const { setEnumItem, removeEnumItem } = menuSlice.actions;

export default menuSlice.reducer;
